module.exports = __webpack_public_path__ + "img/map-peru.07f5b2d9.jpg";